import {PropsWithChildren} from "react";
import {LoadingCenter} from "@bounce/shared/ui";
import {useAuth} from "@bounce/shared/contexts";
import {useGetUserClientDetailsQuery} from "~/api/requests";
import {getBlockedAccountInformation} from "~/pages/account/account/utils";
import {useAccount} from "../hooks";
import {BlockedAccountPage} from "~/new-design/pages/blocked/BlockedAccountPage";
import {useCampaignDialog} from "~/hooks";

export const BlockedAccountGuard = ({children}: PropsWithChildren) => {
  const {userId} = useAuth();
  const {accountId, account} = useAccount();
  const {data: userDetails} = useGetUserClientDetailsQuery({userId}, {enabled: !!userId});

  useCampaignDialog(accountId);

  if (!account) {
    return <LoadingCenter />;
  }

  const {text, reason} = getBlockedAccountInformation(account, userDetails?.state);

  if (reason && text) {
    return <BlockedAccountPage account={account} accountId={accountId} text={text} reason={reason} />;
  }

  return <>{children}</>;
};
